import { WrapErrorEvent } from "src/types/type";

function filterStack(stack: string, message: string, isConsole = false): string {
  let stackArr = stack?.split('\n');
  if(stackArr?.length > 0) {
    // 非UBA打印的错误信息
    if(!/\[UBA\]/.test(message) && ( isConsole || /ConsoleError/.test(stack))) {
      stackArr = stackArr.filter(item => !/ubasdk/.test(item));
    }
    return stackArr.join('\n').replace(/^Error: ConsoleError/, 'ConsoleError');
  }
  return stack;
}
export default function (error: WrapErrorEvent) {
  const args = error.consoleArgs || [];
  const sourceErrorEvent = args.find(arg => arg instanceof ErrorEvent);
  const sourceError = args.find(arg => arg instanceof Error) || sourceErrorEvent?.error;
  const ret = {
    message: error.message,
    stack: error.stack || error.error?.stack,
    filename: error.filename,
    lineno: error.lineno,
    colno: error.colno,
    errorCode: error.ErrorCode,
  };
  if (error.reason) {
    if (error.reason instanceof Error) {
      const promiseError: any = error.reason;
      Object.assign(ret, {
        message: promiseError.message,
        stack: promiseError.stack || error.error?.stack,
        filename: promiseError.filename,
        lineno: promiseError.lineno,
        colno: promiseError.colno,
        errorCode: promiseError.ErrorCode,
      });
    } else if (typeof error.reason === 'object') {
      try {
        ret.message = JSON.stringify(error.reason);
      } catch (err) {
        ret.message = String(error.reason);
      }
    } else {
      ret.message = String(error.reason);
    }
  }
  if (args.length > 0) {
    const first = args[0];
    const errorCode = first?.code || first;
    if(/^E\d{5}$/.test(errorCode)) {
      ret.errorCode = errorCode;
    }
    ret.message = args.join(' ');
  }
  if(ret.stack) {
    ret.stack = filterStack(ret.stack, ret.message, args.length > 0);
    const matchs = ret.stack.match(/at\s+([^\n]+):(\d+):(\d+)/) || ret.stack.match(/@([^\n]+):(\d+):(\d+)/);
    if(matchs && matchs.length === 4) {
      const fileCont = matchs[1];
      const fileMatch = fileCont?.match(/[^\s(]+$/);
      if(fileMatch && fileMatch.length === 1) {
        ret.filename = fileMatch[0];
        ret.lineno = matchs[2];
        ret.colno = matchs[3];
      }
    }
  }
  if (sourceError?.stack && ret.stack) {
    ret.stack += `\n---> 关联Error堆栈：${sourceError.stack}`;
    // 存在关联的原始错误对象时，错误文件及位置信息调整为原始错误对象的
    const matchs = sourceError.stack.match(/at\s+([^\n]+):(\d+):(\d+)/) || ret.stack.match(/@([^\n]+):(\d+):(\d+)/);
    if(matchs && matchs.length === 4) {
      const fileCont = matchs[1];
      const fileMatch = fileCont?.match(/[^\s(]+$/);
      if(fileMatch && fileMatch.length === 1) {
        ret.filename = fileMatch[0];
        ret.lineno = matchs[2];
        ret.colno = matchs[3];
      }
    }
  }
  return ret;
}
